import { GameConstants } from "./GameConstants";
import { PreLoader } from "./scenes/preload/PreLoader";
import { SplashState } from "./scenes/splash/SplashState";
import { FootballFieldState } from "./scenes/match-scene/FootballFieldState";
import { PenaltyFootballFieldState } from "./scenes/penalty-scene/PenaltyFootBallFieldState";
import { MatchResultState } from "./scenes/end-result/MatchResultState";
import { TrophyState } from "./scenes/level-selection/TrophyState";
import { TeamSelectionState } from "./scenes/team-selection-scene/TeamSelectionState";
import { StatsState } from "./scenes/stats/StatsState";
import { DailyRewardState } from "./scenes/daily-reward/DailyRewardState";
import { CreditsState } from "./scenes/credits-scene/CreditsState";
import { Boot } from "./Boot";

    export class Game extends Phaser.Game {

        public static currentInstance: Game;

        constructor() {

            super(GameConstants.GAME_WIDTH, GameConstants.GAME_HEIGHT, Phaser.AUTO, "content", null, false, true);

            Game.currentInstance = this;

            this.state.add("PreLoader", PreLoader, false);

            this.state.add("SplashState", SplashState, false);
            this.state.add("FootballFieldState", FootballFieldState, false);
            this.state.add("PenaltyFootballFieldState", PenaltyFootballFieldState, false);
            this.state.add("MatchResultState", MatchResultState, false);
            this.state.add("TrophyState", TrophyState, false);
            this.state.add("TeamSelectionState", TeamSelectionState, false);
            this.state.add("StatsState", StatsState, false);
            this.state.add("DailyRewardState", DailyRewardState, false);
            this.state.add("CreditsState", CreditsState, false);
            
            this.state.add("Boot", Boot, true);
        }
    }
